module.exports = __webpack_public_path__ + "static/img/H7-b2-2.423f1f94.jpg";